import auth from "../../middlewares/auth";
export const testLectureRoute = [
  {
    path: '/test-lectures',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/test_lecture/TestLectureList'),
    name: 'test_lecture_list',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/test-lecture/add',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/test_lecture/TestLectureForm'),
    name: 'test_lecture_add',
    meta: {
      middleware: [
        auth
      ]
    }
  },
  {
    path: '/test-lecture/edit/:id',
    component: () => import(/* webpackChunkName: "lecture_management" */ '../../views/lecture_management/test_lecture/TestLectureForm'),
    name: 'test_lecture_edit',
    meta: {
      middleware: [
        auth
      ]
    }
  }
];